import { ContractStatus, IPlatformActivityResponse, IPlatformBusinessDeepDive, Plans } from '@torim-app/types';
import { platformUrlBuilder, platformFetch } from './utils';

export interface IPlatformBusinessUpdateDto {
  plan?: Plans;
  isTestBusiness?: boolean;
  contract?: {
    status?: ContractStatus;
    trialStartDate?: string | null;
    trialEndDate?: string | null;
    monthlyPrice?: number | null;
    limits?: {
      sms?: number;
      whatsapp?: number;
      numOfAppointments?: number;
    };
  };
}

export class ActivityApi {
  static async fetchActivityDashboard(days = 14): Promise<IPlatformActivityResponse> {
    const url = platformUrlBuilder({ days }, 'activity');
    const response = await platformFetch(url);
    if (!response.ok) throw 'Failed to fetch activity dashboard';
    return response.json();
  }

  static async fetchBusinessDeepDive(bid: string): Promise<IPlatformBusinessDeepDive> {
    const url = platformUrlBuilder({}, `business/${bid}`);
    const response = await platformFetch(url);
    if (!response.ok) throw 'Failed to fetch business deep dive';
    return response.json();
  }

  static async updateBusiness(bid: string, dto: IPlatformBusinessUpdateDto): Promise<IPlatformBusinessDeepDive> {
    const url = platformUrlBuilder({}, `business/${bid}`);
    const response = await platformFetch(url, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    });
    if (!response.ok) throw 'Failed to update business';
    return response.json();
  }
}
